import { render, staticRenderFns } from "./add_product.vue?vue&type=template&id=939cf7e6&"
import script from "./add_product.vue?vue&type=script&lang=js&"
export * from "./add_product.vue?vue&type=script&lang=js&"
import style0 from "./add_product.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports